// Clean lazy-loaded i18n setup
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enJson from './locales/en.json';

const LANGUAGE_FILES = {
  my: () => import(/* webpackChunkName: "locale-my" */ './locales/my.json'),
  ar: () => import(/* webpackChunkName: "locale-ar" */ './locales/ar.json')
};

// Helper to ensure a language bundle is loaded (lazy) and trigger a re-render once available
const ensureLanguageResources = (lng) => {
  if (!lng || lng === 'en') return;
  if (!LANGUAGE_FILES[lng]) return;
  if (i18n.hasResourceBundle(lng, 'translation')) return; // already loaded
  LANGUAGE_FILES[lng]()
    .then((mod) => {
      const data = mod.default || mod;
      i18n.addResourceBundle(lng, 'translation', data, true, true);
      // React-i18next listens to 'loaded' to trigger re-render; emit if current language matches
      if (i18n.language === lng) {
        try { i18n.emit('loaded', { lng, ns: 'translation' }); } catch (_) {}
      }
    })
    .catch(() => {});
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: enJson } },
    fallbackLng: 'en',
    supportedLngs: ['en', 'my', 'ar'],
    detection: {
      order: ['path', 'navigator', 'htmlTag'],
      lookupFromPathIndex: 0
    },
    interpolation: { escapeValue: false }
  }, () => {
    // After initial detection, if we started on a non-English path (e.g., /my/..), load its bundle
    ensureLanguageResources(i18n.language);
  });

// Also listen for later manual language changes
i18n.on('languageChanged', (lng) => {
  ensureLanguageResources(lng);
});

export default i18n;
